const dataPrefix = 'data-input';

export function input($container, options = {}) {
    // options может содержать:
    // type: 'text' | 'email' | 'password' | 'textarea' и т.д.
    // label: текст для label
    // name: атрибут name
    // value: начальное значение
    // autocomplete: строка для autocomplete
    // required: boolean
    // rows: для textarea — количество строк (опционально)
    const {
        type = 'text',
        label = '',
        name = '',
        value = '',
        autocomplete = '',
        required = false,
        rows = 4,
    } = options;

    renderInput();

    function renderInput() {
        let templateSelector = `[${dataPrefix}-template-text]`;
        if (type === 'textarea') {
            templateSelector = `[${dataPrefix}-template-textarea]`;
        }
        const $template = document.querySelector(templateSelector);
        if (!$template || !$template.content) return;

        // Клонируем фрагмент
        const fragment = $template.content.cloneNode(true);

        // Ищем внутри клона корневой элемент формы
        // Предполагаем, что внутри template единственный корневой div [data-input-form]
        const $formElement = fragment.querySelector(`[${dataPrefix}-form]`);
        if (!$formElement) return;

        // Устанавливаем уникальный id
        const uniqueId = `input-${Date.now()}-${Math.random().toString(36).substr(2, 5)}`;

        // Ищем элемент ввода: input или textarea
        const $inputEl = $formElement.querySelector(`[${dataPrefix}-form-input]`);
        if (!$inputEl) return;

        // Настраиваем атрибуты
        if (type !== 'textarea') {
            $inputEl.setAttribute('type', type);
        }
        if (name) {
            $inputEl.setAttribute('name', name);
        }
        $inputEl.setAttribute('id', uniqueId);
        if (autocomplete) {
            $inputEl.setAttribute('autocomplete', autocomplete);
        } else {
            $inputEl.removeAttribute('autocomplete');
        }
        if (required) {
            $inputEl.setAttribute('required', '');
            $inputEl.setAttribute('aria-required', 'true');
        } else {
            $inputEl.removeAttribute('required');
            $inputEl.setAttribute('aria-required', 'false');
        }
        if (type !== 'textarea') {
            // value для input — устанавливаем свойство, а не атрибут
            $inputEl.value = value || '';
        } else {
            // для textarea: textContent
            $inputEl.textContent = value || '';
            if (rows) {
                $inputEl.setAttribute('rows', rows);
            }
        }


        // Настраиваем label
        const $labelEl = $formElement.querySelector(`[${dataPrefix}-form-label]`);
        if ($labelEl) {
            $labelEl.setAttribute('for', uniqueId);
            $labelEl.textContent = label;
        }

        // Инициализируем анимацию/поведение фокуса
        initInputAnimation($formElement, $inputEl);

        // Прилепляем в контейнер
        $container.appendChild(fragment);
    }

    function initInputAnimation($formEl, $inputEl) {
        // $formEl — элемент с [data-input-form], $inputEl — input или textarea
        if (!$formEl || !$inputEl) return;

        // При загрузке, если уже есть value, ставим active
        if ($inputEl.value && $inputEl.value.trim()) {
            $formEl.classList.add('active');
        }

        $inputEl.addEventListener('focus', () => {
            $formEl.classList.add('active');
        });

        $inputEl.addEventListener('blur', () => {
            if (!$inputEl.value.trim()) {
                $formEl.classList.remove('active');
            }
        });

        // Если нужно, можно слушать input для динамических изменений
        $inputEl.addEventListener('input', () => {
            if ($inputEl.value.trim()) {
                $formEl.classList.add('active');
            }
        });
    }
}
